// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDocumentItemKeyType {
    id: number;
    value: string;
    tableValue: string;
    columnValue: string;
    sortOrder: number;
    active: boolean;
}

export class DocumentItemKeyType implements IDocumentItemKeyType, IBaseType {
    public id: number;
    public value: string;
    public tableValue: string;
    public columnValue: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Customer DocumentItemKeyType
	**/
    get Customer(): IDocumentItemKeyType {
        return this.FromId(1);
    }
    /**
		Returns Vehicle DocumentItemKeyType
	**/
    get Vehicle(): IDocumentItemKeyType {
        return this.FromId(2);
    }
    /**
		Returns VehicleOwnership DocumentItemKeyType
	**/
    get VehicleOwnership(): IDocumentItemKeyType {
        return this.FromId(3);
    }
    /**
		Returns Title DocumentItemKeyType
	**/
    get Title(): IDocumentItemKeyType {
        return this.FromId(4);
    }
    /**
		Returns Registration DocumentItemKeyType
	**/
    get Registration(): IDocumentItemKeyType {
        return this.FromId(5);
    }
    /**
		Returns VehiclePermit DocumentItemKeyType
	**/
    get VehiclePermit(): IDocumentItemKeyType {
        return this.FromId(6);
    }
    /**
		Returns BusinessTransactionNumber DocumentItemKeyType
	**/
    get BusinessTransactionNumber(): IDocumentItemKeyType {
        return this.FromId(7);
    }
    /**
		Returns DriverCredentialID DocumentItemKeyType
	**/
    get DriverCredentialID(): IDocumentItemKeyType {
        return this.FromId(8);
    }
    /**
		Returns Case DocumentItemKeyType
	**/
    get Case(): IDocumentItemKeyType {
        return this.FromId(9);
    }
    /**
		Returns ProhibitionCompliance DocumentItemKeyType
	**/
    get ProhibitionCompliance(): IDocumentItemKeyType {
        return this.FromId(10);
    }
    /**
		Returns PlacardID DocumentItemKeyType
	**/
    get PlacardID(): IDocumentItemKeyType {
        return this.FromId(11);
    }
    /**
		Returns FinanceDisbursementRequest DocumentItemKeyType
	**/
    get FinanceDisbursementRequest(): IDocumentItemKeyType {
        return this.FromId(12);
    }
    /**
		Returns WithdrawalNoticeNoHearing DocumentItemKeyType
	**/
    get WithdrawalNoticeNoHearing(): IDocumentItemKeyType {
        return this.FromId(13);
    }
    /**
		Returns WithdrawalNoticeWithHearing DocumentItemKeyType
	**/
    get WithdrawalNoticeWithHearing(): IDocumentItemKeyType {
        return this.FromId(14);
    }
    /**
		Returns WithdrawalNoticeAdministrativeAction DocumentItemKeyType
	**/
    get WithdrawalNoticeAdministrativeAction(): IDocumentItemKeyType {
        return this.FromId(15);
    }
    /**
		Returns NoticeofRestriction DocumentItemKeyType
	**/
    get NoticeofRestriction(): IDocumentItemKeyType {
        return this.FromId(16);
    }
    /**
		Returns WithdrawalNoticeLawEnforcementAffidavitNoHearing DocumentItemKeyType
	**/
    get WithdrawalNoticeLawEnforcementAffidavitNoHearing(): IDocumentItemKeyType {
        return this.FromId(17);
    }
    /**
		Returns WithdrawalNoticeLawEnforcementAffidavitWithHearing DocumentItemKeyType
	**/
    get WithdrawalNoticeLawEnforcementAffidavitWithHearing(): IDocumentItemKeyType {
        return this.FromId(18);
    }
    /**
		Returns HazmatEndorsementCancellationNotice DocumentItemKeyType
	**/
    get HazmatEndorsementCancellationNotice(): IDocumentItemKeyType {
        return this.FromId(19);
    }
    /**
		Returns WithdrawalNoticeVehicleRegistationConditionNotice DocumentItemKeyType
	**/
    get WithdrawalNoticeVehicleRegistationConditionNotice(): IDocumentItemKeyType {
        return this.FromId(20);
    }
    /**
		Returns ReceiptId DocumentItemKeyType
	**/
    get ReceiptId(): IDocumentItemKeyType {
        return this.FromId(21);
    }
    /**
		Returns NRVCIncidentOOJId DocumentItemKeyType
	**/
    get NRVCIncidentOOJId(): IDocumentItemKeyType {
        return this.FromId(22);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Customer', tableValue: 'Customer', columnValue: 'CustomerNumber', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Vehicle', tableValue: 'Vehicle', columnValue: 'VehicleID', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'VehicleOwnership', tableValue: 'VehicleOwnership', columnValue: 'VehicleOwnershipID', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Title', tableValue: 'Title', columnValue: 'TitleID', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Registration', tableValue: 'Registration', columnValue: 'RegistrationID', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'VehiclePermit', tableValue: 'VehiclePermit', columnValue: 'VehiclePermitID', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'BusinessTransactionNumber', tableValue: 'BusinessTransactionNumber', columnValue: 'BusinessTransactionNumberId', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'DriverCredentialID', tableValue: 'DriverCredentialID', columnValue: 'DriverCredentialID', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'Case', tableValue: 'CaseNumber', columnValue: 'CaseNumberId', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'ProhibitionCompliance', tableValue: 'ProhibitionCompliance', columnValue: 'ProhibitionComplianceId', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'PlacardID', tableValue: 'Placard ID', columnValue: 'Placard ID', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'FinanceDisbursementRequest', tableValue: 'FinanceDisbursementRequest', columnValue: 'FinanceDisbursementRequestId', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'WithdrawalNoticeNoHearing', tableValue: 'WithdrawalNoticeNoHearing', columnValue: 'ProhibitionId', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'WithdrawalNoticeWithHearing', tableValue: 'WithdrawalNoticeWithHearing', columnValue: 'ProhibitionId', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'WithdrawalNoticeAdministrativeAction', tableValue: 'WithdrawalNoticeAdministrativeAction', columnValue: 'ProhibitionId', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: 'NoticeofRestriction', tableValue: 'NoticeofRestriction', columnValue: 'CustomerID', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: 'WithdrawalNoticeLawEnforcementAffidavitNoHearing', tableValue: 'WithdrawalNoticeLawEnforcementAffidavitNoHearing', columnValue: 'ProhibitionId', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, value: 'WithdrawalNoticeLawEnforcementAffidavitWithHearing', tableValue: 'WithdrawalNoticeLawEnforcementAffidavitWithHearing', columnValue: 'ProhibitionId', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, value: 'HazmatEndorsementCancellationNotice', tableValue: 'HazmatEndorsementCancellationNotice', columnValue: 'ProhibitionId', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'WithdrawalNoticeVehicleRegistationConditionNotice', tableValue: 'WithdrawalNoticeVehicleRegistationConditionNotice', columnValue: 'ProhibitionId', sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, value: 'ReceiptId', tableValue: 'Receipt', columnValue: 'ReceiptId', sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, value: 'NRVCIncidentOOJId', tableValue: 'NRVCIncidentOOJ', columnValue: 'NRVCIncidentOOJId', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.value == null ? null : this.value.toString();
    }

    public FromId(id: number): IDocumentItemKeyType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDocumentItemKeyType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDocumentItemKeyType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDocumentItemKeyType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IDocumentItemKeyType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
